(function($, window, document) {
    "use strict";
    $(function() {
        //##Variables
        var $body      = $('body'),
            $window    = $(window),
            $search = $('.search-area'),
            $personalize = $('.personalize-product'),
            $checkoutBtn = $('.woo_amc_footer'),
            $searchHolder   = $('.mainNav'),
            defaultEasing = [0.4, 0.0, 0.2, 1];
        //End Variables

        $search.click(function() {
            $body.toggleClass('searchopened');
            $('.search-holder').toggleClass('searchtoggled');
            $(this).toggleClass('toggled');
            $searchHolder.slideToggle('fast');
        
        });

          $personalize.click(function() {
            $body.toggleClass('personalize-prod');
            $('.personalize-modal').toggleClass('personalizeToggled');
            $(this).toggleClass('toggled');
            $searchHolder.slideToggle('fast');
        
        });
     
        
        $checkoutBtn.click(function(e){
            e.preventDefault();
            window.location.href = globals.checkout_url;
        });
        
          
        (function($){
            $("#content_1").mCustomScrollbar({
                scrollButtons:{
                    enable:true
                }
            });
        })(jQuery);   

        $body.addClass('body-loaded');

        $( "#place_order_fake" ).click(function() {
          $( "#place_order" ).click();
        });

        if ($('.inf-scroll').length > 0) {  
            $('.inf-scroll').initInfScroll();
        }

 


        console.log("%c Developed by: Kutia Digital Agency http://kutia.net", "padding:9px 5px; background:#3c4952; line-height:25px;color: #59bf9d");
    });
}(window.jQuery, window, document));
